import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import {
  ConfirmationDialogService
} from './../../confirmation-dialog/confirmation-dialog.service';
import {
  GlobalSettings
} from '../../global.settings';
import {
  CommonService
} from '../../common.service';
import {
  SharedService
} from '../../shared.service';
import Utils from '../../utils';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import {
  saveAs
} from 'file-saver';
import {
  AuthenticateUserService
} from '../../authenticateuser.service';
import {
  Subscription
} from 'rxjs/Subscription';
import { UtilsService } from 'src/app/utils.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-export-publish',
  templateUrl: './export-publish.component.html',  
  styleUrls: ['./export-publish.component.scss']

})
export class ExportPublishComponent implements OnInit, OnDestroy {
  @Input() fullTaxonomy //hold taxonomy configuration option
  @Input() frontFacing = 'true'; // holds boolean to determine location where component is included for query params
  @Input() publishPermission = false;
  @Input() canUnpublishTaxonomy = false;
  @Input() taxonomyId;
  @Input() taxonomyTitle;
  @Input() taxonomyData;
  @Input() currentTab;
  @Input() exportPermission = true;
  @Input() option: string;
  @Input() publishStatus: string;
  @Input() adoptionStatus = 2;
  @Input() exportedHistory = [];
  @Input() exportCSV = true;
  @Input() isCustomView = false;
  @Input() dropdownList = []; // holds list of export file formats
  @Input() isOnlyExport = false; // holds flag for export only functionality
  @Input() copyTaxonomyObj = null; // holds info obj for the copies of published taxonomy
  @Input() showIcon = false; // holds info obj for the copies of published taxonomy
  @Output() exportEvent: EventEmitter<any>;
  @Output() publishEvent: EventEmitter<any>;
  @Input() canExportXML = false;

  selectedFileType: string = null;

  caseDataPercent = 0;
  coverageDataPercent = 0;
  unMappedNodes = [];
  associatedProjects = [];
  publishHistoryList = [];
  project_status = true;
  form: UntypedFormGroup;
  caseStatusPermission = false; // holds permission of case status
  listOfColumn = [{
    name: 'Project',
    propName: 'project_name',
    class: '',
    type: 'text'
  },
  {
    name: 'Workflow Status',
    propName: 'workflow_status',
    class: '',
    type: 'text'
  },
  {
    name: 'Open Issues',
    propName: 'open_comment_count',
    class: '',
    type: 'text'
  }
  ];
  // ----------------for Common Data table----------------- //
  listOfColumnPublishHistory = [{
    name: 'Published date',
    propName: 'publish_date',
    class: '',
    type: 'date',
    dateType: 'amCalendar'
  },
  {
    name: 'Published By',
    propName: 'published_by',
    class: '',
    type: 'text'
  },
  {
    name: 'Unpublished Date',
    propName: 'unpublish_date',
    class: '',
    type: 'date',
    dateType: 'amCalendar'
  },
  {
    name: 'Unpublished By',
    propName: 'unpublished_by',
    class: '',
    type: 'text'
  }
  ];

  optionList = [];

  preventEdit = false;
  dataArrived = false;
  selectedCASEstatus = 2;
  publishLoader = false;
  downloadLoader = false;
  publishVersionTag = ''; // holds current publish version tag of taxonomy
  sendNotification = false;
  windowResizeSubscription: Subscription;
  orgId = ''; // holds current organization ID
  frontFaceParams = ''; // holds front-facing parameters to call APIs
  isFontFacing = false; //holds font facing page status
  notificationChecked = false;
  csvModalTarget = '';
  customfilteredMetadata;
  casefilteredMetadata;
  customCheckedList = [];
  caseCheckedList = [];
  showCustomDropDown: boolean = false;
  showCaseDropDown: boolean = false;
  selection = 'Select All';
  selectBtn = true;
  isExcludeAssociation = false;

  constructor(
    private sharedService: SharedService,
    private service: CommonService,
    private dialogService: ConfirmationDialogService,
    private authenticateUser: AuthenticateUserService,
    private utilsService: UtilsService,
    private router: Router,
  ) {
    this.exportEvent = new EventEmitter<any>();
    this.publishEvent = new EventEmitter<any>();
    this.sharedService.publishEvent.subscribe((event: any) => {
      if (event.preventEdit !== undefined) {
        this.preventEdit = event.preventEdit;
        this.dataArrived = event.dataArrived;
      }
    });
    this.windowResizeSubscription = this.sharedService.windowResizeEvent.subscribe((item: any) => {
      if (item) {
        this.getPanelHeight();
      }
    });
    this.sharedService.orgDetails.subscribe((data: any) => {
      if (data && data.organization_id) {
        this.orgId = data.organization_id;
        this.frontFaceParams = '?organization_id=' + this.orgId + '&front_facing=' + this.frontFacing;
      }
    });
    
    if (this.router.url.indexOf('app') === -1) {
      this.isFontFacing = true;
    }
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      file_format: new UntypedFormControl(null, [Validators.required])
    });
    this.getAssociatedProjects();
    this.onTaxonomySelected();
    if (this.adoptionStatus) {
      this.selectedCASEstatus = this.adoptionStatus;
    } else {
      this.selectedCASEstatus = 2;
    }
    if (!this.isOnlyExport) {
      this.getPublishHistory();
    }
    this.userRoleRight();
    this.getPanelHeight();
    this.optionList = [{
      name: 'Download',
      type: 'downloadDocument',
      value: true,
      propName: 'downloadUrl',
      url: false,
      check: 'isDownload'
    }];
  }

  getAssociatedProjects() {
    const url = GlobalSettings.PROJECT_STATUS_TO_PUBLISH + '/' + this.taxonomyId + this.frontFaceParams;
    this.service.getServiceData(url).then((res: any) => {
      this.associatedProjects = res;
      this.checkStatus(this.associatedProjects);
    }).catch((ex) => {
      console.log('Exception getUnmappedNodes');
    });
  }

  checkStatus(associatedProjects) {
    let flag = 0;
    for (let project of associatedProjects) {
      if (associatedProjects.length > 0 && project['open_comment_count'] > 0) {
        flag = 1;
        break;
      }
    }
    if (flag === 1) {
      this.project_status = false;
    } else {
      this.project_status = true;
    }
  }


  publishTaxonomy(event) {
    event.preventDefault();
    event.stopPropagation();
    let confirmationMsg = 'Are you sure you want to publish?';
    if (this.caseDataPercent !== 100 || this.coverageDataPercent !== 100) {
      confirmationMsg = 'This taxonomy is CASE compliant ' + this.caseDataPercent +
        '% and mandatory field compliant ' + this.coverageDataPercent + '%. Are you sure you want to publish ?';
    } else if (this.unMappedNodes.length > 0) {
      confirmationMsg = 'This taxonomy has nodes that are not assigned to projects.Are you sure you want to publish?';
    }
    this.dialogService.confirm('Confirm', confirmationMsg)
      .then((confirmed) => {
        if (confirmed) {
          const url = GlobalSettings.PUBLISH_TAXONOMY;
          const body = {
            adoption_status: this.selectedCASEstatus,
            document_id: this.taxonomyId,
            publish_status: 1,
            version_tag: this.publishVersionTag,
            sendNotification: this.sendNotification,
            auth_token: Utils.getCookie('central_auth_token'),
            send_email_to_tenant_users : this.notificationChecked
          };
          this.service.postService(url, body, 0, true).then((res: any) => {
            if (res.success) {
              this.preventEdit = true;
              this.sharedService.sucessEvent.next({
                type: 'publish_taxonomy'
              });

              if (!this.isOnlyExport) {
                this.getPublishHistory();
                this.publishEvent.emit(this.preventEdit);
              }
            } else {
              this.preventEdit = false;
              this.sharedService.sucessEvent.next({
                type: 'error',
                customMsg: res.message ? res.message.toString() : res.message
              });
            }

          }).catch((ex) => {
            console.log('publish service error occured', ex);
            this.preventEdit = false;
          });
        } else {
          console.log('User cancel the dialog');
        }
      })
      .catch(() => {
        console.log('User dismissed the dialog');
      });
  }

  getCaseData(data) {
    this.caseDataPercent = data.progressPercentage;
  }

  getCoverageData(data) {
    this.coverageDataPercent = data.progressPercentage;
  }

  onTaxonomySelected() {
    if (this.taxonomyData) {
      this.iterate(this.taxonomyData, 0);
    }
  }

  iterate(current, depth) {
    if (current && current.children) {
      const children = current.children;
      if (current.project_enabled) {
        if (current.project_enabled === '0') {
          if (current.is_document === 1) {
            this.unMappedNodes.push({
              'key': current.id,
              'value': current.title
            });
          } else {
            this.unMappedNodes.push({
              'key': current.id,
              'value': current.human_coding_scheme + ' ' + current.full_statement
            });
          }
        }
      }
      for (let i = 0, len = children.length; i < len; i++) {
        this.iterate(children[i], depth + 1);
      }
    }
  }


  /* --------- Cancel function start --------- */

  closePublish() {
    if (document.getElementById('closepublishModal')) {
      document.getElementById('closepublishModal').click();
    }
  }

  /* --------- Cancel function end --------- */

  onCancel() {
    this.selectedFileType = null;
    this.form.reset();
  }


  /**
   * On Export modal open
   */
  onExportModalOpen() {
    this.onCancel();
    setTimeout(() => {
      this.utilsService.focusOnModalCloseBtn();
    }, 500);
  }

  /**
   * On Export confirm clicked
   * @param event
   */
  onExportClick(event) {
    this.csvModalTarget = '';
    if (this.selectedFileType && (window.location.href.includes('taxonomies') || this.selectedFileType != 'CSV')) {
      this.exportEvent.emit(this.selectedFileType);
    }else if(this.selectedFileType && this.selectedFileType == 'CSV' && !window.location.href.includes('taxonomies')){
      this.csvModalTarget = '#exportCSVModal';
      this.selection = 'Select All';
      this.selectBtn = true;
      this.isExcludeAssociation = false;
      this.getMetadataList();
    }
  }

  getPublishHistory() {
    const url = GlobalSettings.TAXONOMY_PUBLISH_HISTORY + '/' + this.taxonomyId;
    this.publishHistoryList = [];
    this.publishLoader = true;
    this.service.getServiceData(url).then((res: any) => {
      console.log('publish history response --->', res);
      this.publishHistoryList = res;
      Utils.sortDataArray(this.publishHistoryList, 'publish_number', false, false);
      this.publishHistoryList.forEach(item => {
        let uuid;
        if (item.unpublish_date === '0000-00-00 00:00:00') {
          item.unpublish_date = '';
        }
        if (item.taxonomy_json_file_s3) {
          uuid = item.taxonomy_json_file_s3.replace('.json', '');
        } else {
          uuid = this.taxonomyId;
        }
        item.downloadUrl = GlobalSettings.DOWNLOAD_PUBLISHED_TAXONOMY + '/' + uuid;
        item.isDownload = true;
        item.showOptions = true;
      });
      this.publishLoader = false;
      setTimeout(() => {
        this.getPanelHeight();
        this.closePublish();
      }, 500);
    }).catch((ex) => {
      this.publishHistoryList = [];
      this.publishLoader = false;
      console.log('getPublishHistory ex ');
    });
  }

  unpublishTaxonomy() {
    const url = GlobalSettings.PUBLISH_TAXONOMY;
    const body = {
      adoption_status: this.selectedCASEstatus,
      document_id: this.taxonomyId,
      publish_status: 2,
      auth_token: Utils.getCookie('central_auth_token'),
      send_email_to_tenant_users : this.notificationChecked
    };
    this.preventEdit = false;
    this.service.postService(url, body, 0, true).then((res: any) => {
      if (res.success) {
        console.log('unpublished', res);
        this.sharedService.sucessEvent.next({
          type: 'unpublish_taxonomy'
        });
        if (!this.isOnlyExport) {
          this.getPublishHistory();
          this.publishEvent.emit(this.preventEdit);
        }
      } else {
        this.sharedService.sucessEvent.next({
          type: 'error',
          customMsg: res.message ? res.message.toString() : res.message
        });
      }
    });
  }

  downloadTaxonomyJSON(event) {
    const url = event.downloadUrl;
    const type = 'JSON_WITH_FORMATTED';
    const contentType = 'text/plain';
    const publishId = event.taxonomy_json_file_s3;
    this.downloadLoader = true;
    this.service.downloadServiceData(url, type).then((res: any) => {
      try {
        if (res.data !== null) {
          this.saveToFileSystem(res, contentType, publishId);
        } else {
          this.sharedService.sucessEvent.next({
            customMsg: res.message,
            type: 'error'
          });
          this.downloadLoader = false;
        }
      } catch (error) {
        console.log('onExportTaxonomy error ', error);
        this.downloadLoader = false;
      }

    }).catch(ex => {
      this.downloadLoader = false;
    });
  }

  private saveToFileSystem(response, contentType, name) {
    let blob = null;
    blob = new Blob([JSON.stringify(response.data)], {
      type: contentType
    });

    const title = name;

    saveAs(blob, title);
    this.downloadLoader = false;
  }

  onOptionClicked(event) {
    if (event.clickedOn === 'downloadDocument') {
      this.downloadTaxonomyJSON(event.data);
    }
  }


  userRoleRight() {
    if (this.authenticateUser.authenticTaxonomy('Change CASE Status')) {
      this.caseStatusPermission = true;
    } else {
      this.caseStatusPermission = false;
    }
  }

  /* --------- Functionality for document page height calculation start --------- */

  getPanelHeight() {
    const windowHeight = window.innerHeight;
    const extraHeight = 236;
    let titleHeight;
    let tabPanelHeight;
    let commentPanelHeight;
    if (document.getElementById('topNav')) {
      titleHeight = document.getElementById('topNav').offsetHeight;
    }
    if (document.getElementById('tabPanel')) {
      tabPanelHeight = document.getElementById('tabPanel').offsetHeight;
    }

    commentPanelHeight = windowHeight - (titleHeight + tabPanelHeight + extraHeight);

    if (document.getElementById('exportPublishTable')) {
      document.getElementById('exportPublishTable').style.height = commentPanelHeight + 'px';
    }
  }

  /* --------- Functionality for document page height calculation end --------- */

  ngOnDestroy() {
    if (this.windowResizeSubscription) {
      this.windowResizeSubscription.unsubscribe();
    }
  }

  onCsvExportClick(ev){
    this.exportEvent.emit([this.selectedFileType,this.isExcludeAssociation,this.caseCheckedList,this.customCheckedList]);
  }

  getMetadataList() {
    this.customfilteredMetadata = [];
    this.casefilteredMetadata = [];
    this.customCheckedList = [];
    this.caseCheckedList = [];
    const url = GlobalSettings.GET_METADATA_LIST ;
    this.service.getServiceData(url).then((res: any) => {
      res.metadata.forEach(element => {
        window.document.body.classList.add('modal-open');
        if(element.name == 'Human Coding Scheme' || element.name == 'Full Statement' || element.name == 'Title'){
          element.checked = true;
          this.caseCheckedList.push(element.internal_name);
        }
        if(element.is_document != 3){
          if(element.is_custom == 1){
            this.customfilteredMetadata.push(element);
          }else if(element.is_custom == 0){
            this.casefilteredMetadata.push(element);
          }
        }
      });
    }).catch((ex) => {
      console.log('Error caught while fetching metadata list');
    });
  }

  getSelectedValue(isChecked: boolean, name: string, checkedList) {
    if (isChecked) {
      checkedList.push(name);
    } else {
      const index = checkedList.indexOf(name);
      if (index > -1) {
        checkedList.splice(index, 1);
      }
    }
    this.selection = this.casefilteredMetadata.every(node => node.checked) && this.customfilteredMetadata.every(node => node.checked) ? 'Deselect All' : 'Select All' ;
    this.selectBtn = this.selection == 'Select All' ? true : false;
  }

  toggleExclude(){
    this.isExcludeAssociation = !this.isExcludeAssociation;
  }

  toggleSelect(){
    this.selectBtn = !this.selectBtn;
    if(this.selectBtn){
      return this.selection = 'Select All';
    }else{
      return this.selection = 'Deselect All';
    }
  }

  selectAlltoggle(){
    let selectType = this.toggleSelect();
    if(selectType == 'Select All'){
      this.customCheckedList = [];
      this.caseCheckedList = [];
      this.selectionHandler('deSelect');
    }else if(selectType == 'Deselect All'){
      this.selectionHandler('select');
    }
  }

  selectionHandler(select){
    this.customfilteredMetadata.forEach(element => {
      this.filterMetadataSelectionHandler(select,element,this.customCheckedList, 'custom');
    });
    this.casefilteredMetadata.forEach(element => {
      this.filterMetadataSelectionHandler(select,element,this.caseCheckedList,'case');
    });
  }

  filterMetadataSelectionHandler(select,element,arrayList,type){
    if(select == 'select'){
      element.checked = true;
      if(type == 'case' && !arrayList.includes(element.internal_name)){
        arrayList.push(element.internal_name);
      }else if(type == 'custom' && !arrayList.includes(element.name)){
        arrayList.push(element.name);
      }
    }
    else if(select == 'deSelect'){
      element.checked = false;
      if(element.name == 'Human Coding Scheme' || element.name == 'Full Statement' || element.name == 'Title'){
        element.checked = true;
        this.caseCheckedList.push(element.internal_name);
      }
    }
  }
}
